/**
 * Pinia email is in-memory. Persist across refresh for forgot-password /
 * MFA-direct so we do not auto-drop onto the email-only "reset link" screen
 * (NA-4597).
 */
export const PWD_RESET_EMAIL_SESSION_KEY = 'jcPwdResetEmail';

export function readPwdResetSessionEmail(): string {
  try {
    return window.sessionStorage.getItem(PWD_RESET_EMAIL_SESSION_KEY) || '';
  } catch {
    return '';
  }
}

export function writePwdResetSessionEmail(email: string): void {
  if (!email) {
    return;
  }
  try {
    window.sessionStorage.setItem(PWD_RESET_EMAIL_SESSION_KEY, email);
  } catch {
    // ignore quota / private-mode failures
  }
}

export function clearPwdResetSessionEmail(): void {
  try {
    window.sessionStorage.removeItem(PWD_RESET_EMAIL_SESSION_KEY);
  } catch {
    // ignore
  }
}

/** Restore into store when empty; always re-stash when email is known. */
export function syncPwdResetSessionEmail(
  getEmail: () => string,
  setEmail: (email: string) => void,
): string {
  let email = getEmail();
  if (!email) {
    email = readPwdResetSessionEmail();
    if (email) {
      setEmail(email);
    }
  }
  if (email) {
    writePwdResetSessionEmail(email);
  }
  return email;
}
